import React, { useEffect, useState } from 'react'
import Button from '../atoms/Button'
import FilterBox from '../molecules/FilterBoxPage'
import { ReactComponent as Filter } from '../svgs/filter.svg'
import CustomTable from '../organisms/CustomTable'
import RecallConfirmation from '../molecules/RequestPageDialogs/RecallConfirmation'
import RequestConfirmation from '../molecules/RequestPageDialogs/RequestConfirmation'
import RecallConfirmed from '../molecules/RequestPageDialogs/RecallConfirmed'
import RequestConfirmed from '../molecules/RequestPageDialogs/RequestConfirmed'
import RequestDialog from '../molecules/RequestPageDialogs/RequestDialog'
import SearchBar from '../atoms/SearchButton'
import Pagination from '../atoms/Pagination'
import { Skeleton } from 'antd'
import toast from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { requestTable } from '../../utils/API/requestTable'
import Badge from '../atoms/Badge'
import ViewRequestsDocuments from '../atoms/ViewRequestsDocuments'
import TransferRequestRemarks from '../atoms/TransferRequestRemarks'

const getLabel = {
  Requested: 'Requested',
  'In-Process': 'In-Process',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  'In-Holding': 'In-Holding',
  Refused: 'Refused'
}

const ActionButtons = ({
  requestHandler,
  recallHandler,
  isRequested,
  isCancelled,
  requestDocumentsHandler,
  remarksHandler,
  status
}) => {
  const showRequestandRecallButton =
    status === 'Requested' || status === 'In-Process'

  const showRequestButton = status === 'In-Holding'

  const showViewButton = status === 'Completed'

  return (
    <div>
      {showRequestButton && (
        <Button
          varient={'secondary'}
          onClick={requestHandler}
          className={`text-white w-[4.3rem] bg-blue-800 text-[0.56rem] h-[1.875rem] font-medium ${
            isRequested ? 'bg-grey-500 cursor-not-allowed' : ''
          }`}
          disabled={isRequested}
        >
          Request
        </Button>
      )}
      {isCancelled && (
        <Button
          color={'red'}
          varient={'secondary'}
          onClick={remarksHandler}
          className={'text-red-700 px-6 py-2 text-xs bg-red-100'}
        >
          Remarks
        </Button>
      )}
      {showRequestandRecallButton && (
        <div className='flex gap-x-3'>
          <Button
            varient={'secondary'}
            onClick={requestHandler}
            className={`text-white w-[4.3rem] bg-blue-800 text-[0.56rem] h-[1.875rem] font-medium ${
              isRequested || status === 'In-Process' || status === 'Refused'
                ? 'bg-grey-500 cursor-not-allowed'
                : ''
            }`}
            disabled={
              isRequested || status === 'In-Process' || status === 'Refused'
            }
          >
            Request
          </Button>

          <Button
            varient={'secondary'}
            onClick={recallHandler}
            className={`text-blue-800 w-[4.3rem] text-[0.56rem] h-[1.875rem] font-medium bg-blue-300 ${
              status === 'Cancelled' || status === 'Refused'
                ? 'bg-grey-500 text-white cursor-not-allowed'
                : ''
            }`}
            disabled={status === 'Cancelled' || status === 'Refused'}
          >
            Recall
          </Button>
        </div>
      )}
      {showViewButton && (
        <Button
          color={'lightblue'}
          varient={'secondary'}
          onClick={requestDocumentsHandler}
          className='text-blue-800  px-3 text-[0.56rem] h-[1.875rem] font-medium'
        >
          View Documents
        </Button>
      )}
    </div>
  )
}

const headerData = [
  'Project Name',
  'Project ID',
  'Category',
  'No. of credits',
  'Token Type',
  'Registry',
  'Status',
  'Action'
]

const RequestPage = () => {
  const dispatch = useDispatch()
  const [recallConfirmationState, setRecallConfirmationState] = useState(false)
  const [requestConfirmationState, setRequestConfirmationState] =
    useState(false)
  const [requestDialogState, setRequestDialogState] = useState(false)
  const [requestConfirmedState, setRequestConfirmedState] = useState(false)
  const [recallConfirmedState, setRecallConfirmedState] = useState(false)
  const [requestData, setRequestData] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchItem, setSearchItem] = useState('')
  const [selectedRegistry, setSelectedRegistry] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedToken, setSelectedToken] = useState(null)
  const [openViewDocuments, setOpenViewDocuments] = useState(false)
  const [requestDocuments, setRequestDocuments] = useState([])
  const [filterData, setFilterData] = useState(null)
  const [remarksData, setRemarksData] = useState('')
  const [remarksPopup, setRemarksPopup] = useState(false)
  const currentPage = Number(searchParams.get('page')) || 1
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  })

  const pageSize = 8

  const transformData = originalData => {
    const transformedData = []
    if (originalData.holdings_result) {
      transformedData.push(
        ...originalData.holdings_result.paginatedData.map(
          ({ project, userData, availableCredits, status_of_request }) => [
            project.projectName || '',
            project.projectId || '',
            project.categoryDetails?.categoryName || '',
            availableCredits,
            project.tokenType || '',
            project.registryDetails?.registryName || '',
            <Badge varient={'In-Holding'}>
              <div className='flex justify-center items-center w-36 text-xs h-5 '>
                {getLabel['In-Holding']}
              </div>
            </Badge>,
            <ActionButtons
              isRequested={
                status_of_request === 'Requested' ||
                status_of_request === 'Cancelled'
              }
              status={'In-Holding'}
              requestHandler={() => {
                handleRequestedClick(project, userData, availableCredits)
                setRequestConfirmationState(true)
              }}
              recallHandler={() => {
                handleRecallButton(project)
                setRecallConfirmationState(true)
              }}
            />
          ]
        )
      )
    }
    if (originalData.request_result) {
      transformedData.push(
        ...originalData.request_result.paginatedData.map(
          ({
            project,
            user,
            no_of_credits,
            status_of_request,
            request_documents,
            admin_remarks,
            _id
          }) => [
            project.project_name || '',
            project.project_id || '',
            project.project.category.category_id.name || '',
            no_of_credits,
            project.token_type || '',
            project.project.registry_name?.registryName || '',
            <Badge varient={status_of_request}>
              <div className='flex justify-center items-center w-36 text-xs h-5 '>
                {getLabel[status_of_request]}
              </div>
            </Badge>,
            <ActionButtons
              isRequested={status_of_request === 'Requested'}
              isCancelled={
                status_of_request === 'Cancelled' ||
                status_of_request === 'Refused'
              }
              status={status_of_request}
              requestHandler={() => {
                handleRequestClick(project, user, no_of_credits)
                setRequestConfirmationState(true)
              }}
              recallHandler={() => {
                handleRecallButton(project, _id)
                setRecallConfirmationState(true)
              }}
              requestDocumentsHandler={() => {
                handleDocView(request_documents)
              }}
              remarksHandler={() => {
                handleRemarks(admin_remarks)
              }}
            />
          ]
        )
      )
    }

    return transformedData
  }

  const handleRemarks = remarks => {
    setRemarksData(remarks)
    setRemarksPopup(true)
  }

  const handleDocView = rowData => {
    // console.log(rowData)
    setRequestDocuments(rowData)
    setOpenViewDocuments(true)
  }

  const handleRecallButton = (project, _id) => {
    setSelectedRowData({ Project: project._id, requestId: _id })
  }

  const handleRequestedClick = (rowData, userData, availableCredits) => {
    setSelectedRowData({
      Username: userData.userName,
      Project: rowData._id,
      'Project ID': rowData.projectId,
      'No. of Credits': availableCredits
    })
  }

  const handleRequestClick = (rowData, user, availableCredits) => {
    setSelectedRowData({
      Username: user.name,
      Project: rowData._id,
      'Project ID': rowData.project_id,
      'No. of Credits': availableCredits
    })
  }

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await requestTable(
        {
          // filterData: filterData,
          categoryId: selectedCategory,
          registries: selectedRegistry ? [selectedRegistry] : null,
          tokenType: selectedToken,
          page: currentPage,
          pageSize,
          searchQuery: searchItem
        },
        dispatch
      )

      if (response.success) {
        const transformedData = transformData(response.data)

        setRequestData(transformedData)
        setPagination({
          totalItems: response.data.request_result.totalDocs,
          totalPages: response.data.request_result.totalPages
        })
      } else {
        toast.error(response.message || 'Failed to fetch data')
      }
    } catch (error) {
      toast.error('Something went wrong!')
    } finally {
      setLoading(false)
    }
  }

  const handleRecallConfirmationOk = async () => {
    setRecallConfirmationState(false)
    setRecallConfirmedState(true)
    await fetchData()
  }

  const handleRequestConfirmationOk = async () => {
    setRequestConfirmationState(false)
    setRequestDialogState(true)
    await fetchData()
  }

  const handleSearch = () => {
    // console.log(searchItem)
  }

  useEffect(() => {
    fetchData()
  }, [
    filterData,
    recallConfirmedState,
    requestConfirmedState,
    currentPage,
    searchItem
  ])

  const handleRegistryCheck = e => {
    {
      const selectedValue = e.target.value
      setSelectedRegistry(selectedValue)
    }
  }

  const handleFilterButtonClick = () => {
    setFilterDialogOpen(true)
  }

  const handleFilterDialogClose = () => {
    setSelectedRegistry([])
    setSelectedCategory('')
    setSelectedToken('')
    setFilterData(null)
    setFilterDialogOpen(false)
  }

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false)
    setFilterData({
      categoryId: selectedCategory,
      registries: selectedRegistry ? [selectedRegistry] : null,
      tokenType: selectedToken
    })
  }

  const handleCategoryChange = e => {
    const selectedCategory = e.target.value
    setSelectedCategory(selectedCategory)
  }

  const handleTokenChange = event => {
    const selectedToken = event.target.value
    setSelectedToken(selectedToken)
  }

  return (
    <>
      <RecallConfirmation
        open={recallConfirmationState}
        onCancel={() => setRecallConfirmationState(false)}
        onOk={handleRecallConfirmationOk}
        selectedRowData={selectedRowData}
      />
      <RequestConfirmation
        open={requestConfirmationState}
        onCancel={() => setRequestConfirmationState(false)}
        onOk={handleRequestConfirmationOk}
      />
      <RecallConfirmed
        open={recallConfirmedState}
        onCancel={() => setRecallConfirmedState(false)}
      />
      <RequestConfirmed
        open={requestConfirmedState}
        onCancel={() => setRequestConfirmedState(false)}
      />
      <RequestDialog
        open={requestDialogState}
        onOk={() => {
          setRequestDialogState(false)
          setRequestConfirmedState(true)
          setRequestConfirmationState(false)
        }}
        selectedRowData={selectedRowData}
        selectedColumns={['Registry', 'Username', 'Project ID']}
        onCancel={() => {
          setRequestDialogState(false)
          setRequestConfirmationState(false)
        }}
      />
      <ViewRequestsDocuments
        open={openViewDocuments}
        requestDocuments={requestDocuments}
        onCancel={() => setOpenViewDocuments(false)}
      />
      <div className='bg-[#F4F6FA] h-full w-full p-6'>
        <div className='text-[1.75rem] font-bold mb-4'>Request</div>
        <div className='w-full mt-8 h-[calc(90vh-2.4rem)] bg-white rounded-3xl shadow-formShadow flex flex-col'>
          <div className='flex justify-between pt-5 pb-12'>
            <div className='w-80 border-2 border-grey-800 rounded-lg mx-5 mb-5 '>
              <SearchBar
                onSearch={handleSearch}
                searchItem={searchItem}
                setSearchItem={setSearchItem}
                variant='secondaryxl'
                className='text-black'
                borderColor='border-none'
                placeholderColor='black'
                inputBackground='white'
                svgStrokeColor='black'
                inputWidth='72'
                inputHeight='8'
              />
            </div>
            <div className='pr-7 '>
              <Button
                className='flex justify-center items-center gap-x-2 px-2 py-2 mb-3 '
                borderColor={'gray'}
                varient={'secondary'}
                onClick={handleFilterButtonClick}
              >
                {' '}
                <div className='flex gap-x-2 items-center'>
                  <Filter className='w-4 h-4' />
                  <span>Filter</span>
                </div>
              </Button>
            </div>
          </div>
          <div className='flex-grow overflow-y-auto'>
            {loading ? (
              <>
                <CustomTable data={[]} headerData={headerData} />
                <div className='flex flex-col gap-y-4 p-4'>
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                </div>
              </>
            ) : (
              <CustomTable
                data={
                  Array.isArray(requestData)
                    ? requestData.map(requestData => Object.values(requestData))
                    : []
                }
                headerData={headerData}
              />
            )}
          </div>
          {pagination.totalPages > 1 && (
            <div className='pb-4 px-3'>
              <Pagination
                current={currentPage}
                total={pagination.totalItems}
                pageSize={pageSize}
                setCurrentPage={page => setSearchParams({ page })}
              />
            </div>
          )}
        </div>
        {isFilterDialogOpen && (
          <FilterBox
            open={isFilterDialogOpen}
            onCancel={handleFilterDialogClose}
            onOk={handleFilterDialogSubmit}
            page='holdings'
            selectedRegistry={selectedRegistry}
            onCheckRegistry={handleRegistryCheck}
            selectedCategory={selectedCategory}
            onSelectCategory={handleCategoryChange}
            selectedToken={selectedToken}
            onSelectToken={handleTokenChange}
          />
        )}
        {remarksPopup && (
          <TransferRequestRemarks
            open={remarksPopup}
            remarks={remarksData}
            onCancel={() => setRemarksPopup(false)}
          />
        )}
      </div>
    </>
  )
}

export default RequestPage
